<template>
  <div
    class="million-users-testimonial"
    :class="{ 'million-users-testimonial--active': isActive }"
  >
    <div class="million-users-testimonial__header">
      <img
        :src="image"
        alt=""
        width="90"
        height="90"
        class="million-users-testimonial__image"
      />
      <h2 class="million-users-testimonial__name">{{ person.name }}</h2>
      <p
        class="million-users-testimonial__subtitle"
        v-html="person.subtitle"
      ></p>
    </div>

    <div class="million-users-testimonial__body">
      <p class="million-users-testimonial__text">{{ person.text }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  person: {
    name: string
    subtitle: string
    text: string
  }
  image: string
  isActive: boolean
}>()
</script>

<style lang="scss" scoped>
.million-users-testimonial {
  display: grid;
  justify-content: center;
  width: 100%;
  max-width: var(--onboarding-inner-width);
  flex-shrink: 0;
  scroll-snap-align: center;
  // Hard-coding height is never ideal,
  // but it's necessary to align the
  // testimonial wrapper with the animation
  // of the profile image.
  height: 380px;
  // Only show the active element.
  opacity: 0;
  transition: opacity 0.3s;

  &:first-child {
    margin-left: 100%;
  }
  &:last-child {
    margin-right: 100%;
  }

  &__image {
    position: absolute;
    top: -45px;
    left: calc(50% - 45px);
    width: 90px;
    height: 90px;
    border-radius: 90px;
    border: 6px solid #ff815b;
  }

  &__header {
    position: relative;
    padding: 16px;
    padding-top: 52px;
    border-radius: 24px;
    border: 1px solid $c-border-7;
    text-align: center;
    background: $c-bg;
    box-shadow:
      0 1px 5px 0 rgba(255, 255, 255, 0.1),
      0 8px 15px 0 rgba(20, 28, 49, 0.1);
    z-index: 1;
  }

  &__body {
    position: relative;
    border-radius: 24px;
    border: 1px solid $c-border-7;
    text-align: center;
    background: $c-bg;
    min-height: 0;
    overflow: hidden;
    box-shadow:
      0 1px 5px 0 rgba(255, 255, 255, 0.1),
      0 8px 15px 0 rgba(20, 28, 49, 0.1);

    &:after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 24px;
      background: linear-gradient(0deg, $c-bg 20%, rgba($c-bg, 0));
    }
  }

  &__name {
    font-size: 20px;
    line-height: 24px;
  }

  &__subtitle {
    font-size: 14px;
    line-height: 22px;
  }

  &__text {
    padding: 24px;
    max-height: 100%;
    overflow-y: auto;
    font-size: 16px;
    line-height: 24px;
    color: $c-black-15;
    @media (max-width: 350px) {
      padding-inline: 16px;
    }
  }
}

.million-users-testimonial--active {
  opacity: 1;
}
</style>
